// extracted by mini-css-extract-plugin
export var addToCartButton = "_ms-b";
export var arrowButtonContainer = "_ms-9";
export var arrowButtonIcon = "_ms-a";
export var carouselArrowButton = "_ms-6";
export var carouselElementContainer = "_ms-1";
export var left = "_ms-7";
export var productDisplayCarouselContainer = "_ms-0";
export var productTileContainer = "_ms-2";
export var productTileImage = "_ms-4";
export var productTileImageContainer = "_ms-3";
export var productTileTitle = "_ms-5";
export var right = "_ms-8";
export var sliderOverflow = "_ms-c";